export const environment = {
	production: false,
	client_id: "1_47ma9q2hh3uoo4gg4wkkos08o0800w0s4o0ssockcsggsks4c8",
	client_secret: "3zaif1speb8kccok000scg08480os88g4c4owswc0w0o0c4g4s",
	API_GOOGLE: "AIzaSyCoRb2AD9QvtUWtJ3JNgrB85bwFIi2KeCE",
	BASE_SERVER_URL: "https://openfiber-backend-api-73-review34.mashfrogcloud.com",
	BASE_COVERAGE_URL: "https://openfiber-backend-api-73-review34.mashfrogcloud.com/api2/marketing/data/heat/",
	BASE_KML_URL: "https://openfiber-backend-api-73-review34.mashfrogcloud.com/api2/marketing/data/kml/",
	BASE_KMLS_URL: "https://openfiber.it/api2/env/dev/marketing/data/kml/",
	DOMAIN_URL: "https://openfiber-backend-api-73-review34.mashfrogcloud.com",
	MAIN_URL: "https://of-wp-jb-dev.mashfrog.com/",
	redirectSSOUrl: "https://openfiber-marketing-website-82-review112.mashfrogcloud.com/marketing",
	redirectSSOErr: "https://openfiber-marketing-website-82-review112.mashfrogcloud.com/marketing",
	translate: true,
	KML_VERSION: 12,
	ASSETS_VERSION: 1,
	show_massive_company_project: true,
	LOCAL: true,
	show_line_network_p2p: true,
	show_agf: true,
	path_imgs_markers: "./assets/imgs/markers_2"
}
